import React, { createContext, useContext, useState } from 'react';

interface AreasServiciosAll {
    empresaId: number;
    areasServicios: any[]
}

interface AreasServiciosAllContextProps {
    areasServicios: AreasServiciosAll;
    setAreasServicios: React.Dispatch<React.SetStateAction<AreasServiciosAll>>;
}


const AreasServiciosAllContext = createContext<AreasServiciosAllContextProps | undefined>(undefined);

export const AreasServiciosAllProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [areasServicios, setAreasServicios] = useState<AreasServiciosAll>({ empresaId: 0, areasServicios: [] });

    return (
        <AreasServiciosAllContext.Provider value={{ areasServicios, setAreasServicios }}>
            {children}
        </AreasServiciosAllContext.Provider>
    );
};

// Hook
export const useAreasServiciosAll = () => {
    const context = useContext(AreasServiciosAllContext);
    if (!context) {
        throw new Error("useAreasServiciosAll debe ser usado dentro de un AreasServiciosAllProvider");
    }
    return context;
};
